import { useMemo, useState } from "react";
import { categories, feedItems } from "@/mocks/dramaData";

export default function CategoryFeed() {
  const [active, setActive] = useState("drama");
  const [query, setQuery] = useState("");

  const list = useMemo(() => {
    const source = feedItems[active] || [];
    if (!query.trim()) return source;
    return source.filter((it) => it.title.includes(query.trim()) || it.summary.includes(query.trim()));
  }, [active, query]);

  const hasResult = list.length > 0;

  return (
    <section id="feed" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="mb-3 inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-bold text-primary-800">
            <i className="ri-grid-fill"></i> 分类吃瓜
          </span>
          <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-4xl">
            按兴趣，精准吃到圈内瓜
          </h2>
          <p className="mt-3 text-sm text-foreground-700 md:text-base">
            选择你关心的领域，快速浏览近期热点与动态，也可直接搜索关键词。
          </p>
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-4 lg:flex-row">
          <div className="flex max-w-full flex-wrap justify-center gap-1 rounded-full bg-background-100 p-1">
            {categories.map((c) => (
              <button
                key={c.key}
                onClick={() => setActive(c.key)}
                className={`whitespace-nowrap rounded-full px-5 py-2 text-sm font-semibold transition cursor-pointer ${
                  active === c.key
                    ? "bg-foreground-950 text-background-50"
                    : "text-foreground-700 hover:bg-background-200/80 hover:text-primary-700"
                }`}
              >
                {c.label}
              </button>
            ))}
          </div>

          <div className="flex w-full max-w-md items-center gap-2 rounded-full bg-background-100 px-4 py-2 ring-1 ring-background-200 focus-within:ring-2 focus-within:ring-primary-400">
            <i className="ri-search-line text-base text-foreground-400"></i>
            <input
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder={`搜索${categories.find((c) => c.key === active)?.label || ""}相关关键词`}
              className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
            />
            {query && (
              <button onClick={() => setQuery("")} aria-label="清空" className="cursor-pointer text-foreground-400 hover:text-foreground-700">
                <i className="ri-close-circle-fill"></i>
              </button>
            )}
          </div>
        </div>

        <p className="mt-4 text-center text-xs text-foreground-500 lg:text-left">
          {categories.find((c) => c.key === active)?.desc}
        </p>

        {hasResult ? (
          <div className="mt-8 grid gap-4 md:grid-cols-2">
            {list.map((it) => (
              <article
                key={it.title}
                className="group cursor-pointer rounded-2xl border border-background-200 bg-background-100/50 p-5 transition hover:border-primary-200 hover:bg-background-100 md:p-6"
              >
                <div className="flex items-center gap-2 text-xs">
                  <span className="flex h-2 w-2 rounded-full bg-accent-500"></span>
                  <span className="whitespace-nowrap font-semibold text-accent-700">{it.tag}</span>
                  <span className="text-foreground-400">{it.time}</span>
                  <span className="ml-auto inline-flex items-center gap-1 text-foreground-500">
                    <i className="ri-fire-fill text-accent-500"></i>
                    {it.hot}
                  </span>
                </div>
                <h3 className="mt-3 font-heading text-lg font-bold leading-snug text-foreground-950 group-hover:text-primary-700">
                  {it.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{it.summary}</p>
                <div className="mt-4 h-1 max-w-[220px] overflow-hidden rounded-full bg-background-200">
                  <div className="h-full rounded-full bg-gradient-to-r from-primary-500 to-accent-500" style={{ width: `${it.hot}%` }}></div>
                </div>
              </article>
            ))}
          </div>
        ) : (
          <div className="mt-10 flex flex-col items-center gap-3 rounded-2xl border border-dashed border-background-300 bg-background-100/50 py-16 text-center">
            <i className="ri-inbox-2-line text-4xl text-foreground-300"></i>
            <p className="text-sm text-foreground-600">没有找到「{query}」相关的内容</p>
            <button
              onClick={() => setQuery("")}
              className="cursor-pointer whitespace-nowrap rounded-full bg-primary-500 px-5 py-2 text-sm font-semibold text-background-50 hover:bg-primary-600"
            >
              清除搜索
            </button>
          </div>
        )}
      </div>
    </section>
  );
}